module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.RU.b93438a7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.RU.png
// module id = 1188
// module chunks = 16